/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Css/BusinessSolution.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../utils/Function';

const BusinessSolution = () => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);
  const [particles, setParticles] = useState([]);
  const [particles2, setParticles2] = useState([]);
  const [cornerParticles, setCornerParticles] = useState([]);
  const [cornerParticles2, setCornerParticles2] = useState([]);
  const buttonRef = useRef(null);
  const buttonRef2 = useRef(null);
  
  // Product states
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [firstProduct, setFirstProduct] = useState(null);
  const [secondProduct, setSecondProduct] = useState(null);

  // Fetch products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_URL}/product.php/get?limit=2&is_active=1`);
        const data = await response.json();
        
        if (data.success && data.products.length > 0) {
          setProducts(data.products);
          setFirstProduct(data.products[0]);
          setSecondProduct(data.products[1] || data.products[0]);
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Truncate description to 4 lines (approximately 200 characters)
  const truncateDescription = (text, maxLength = 200) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength).trim() + '...';
  };

  const generateParticles = (count, x, y) => {
    const newParticles = [];
    for (let i = 0; i < count; i++) {
      newParticles.push({
        id: Math.random(),
        x: x || Math.random() * 100,
        y: y || Math.random() * 100,
        size: Math.random() * 4 + 2,
        duration: Math.random() * 1 + 0.5,
        delay: Math.random() * 0.5
      });
    }
    return newParticles;
  };

  const generateCornerParticles = (count, buttonRect) => {
    if (!buttonRect) return [];
    
    const newParticles = [];
    
    for (let i = 0; i < count; i++) {
      const startX = buttonRect.right - 8;
      const startY = buttonRect.bottom - 8;
      
      const angle = Math.random() * Math.PI / 3 + Math.PI / 6;
      const distance = 80 + Math.random() * 200;
      
      const endX = startX + Math.cos(angle) * distance;
      const endY = startY + Math.sin(angle) * distance;
      
      const midX1 = startX + Math.cos(angle) * distance * 0.2;
      const midY1 = startY + Math.sin(angle) * distance * 0.2;
      const midX2 = startX + Math.cos(angle) * distance * 0.5;
      const midY2 = startY + Math.sin(angle) * distance * 0.5;
      const midX3 = startX + Math.cos(angle) * distance * 0.8;
      const midY3 = startY + Math.sin(angle) * distance * 0.8;
      
      const speedTypes = ['slow', 'medium', 'fast'];
      const speed = speedTypes[Math.floor(Math.random() * speedTypes.length)];
      
      const shapeTypes = ['circle', 'blob', 'drop'];
      const shape = shapeTypes[Math.floor(Math.random() * shapeTypes.length)];
      
      const baseColors = [
        'rgba(72, 52, 212, 0.9)',
        'rgba(104, 109, 224, 0.8)',
        'rgba(91, 33, 182, 0.7)',
      ];
      const color = baseColors[Math.floor(Math.random() * baseColors.length)];
      
      newParticles.push({
        id: Math.random(),
        startX: `${startX}px`,
        startY: `${startY}px`,
        endX: `${endX}px`,
        endY: `${endY}px`,
        midX1: `${midX1}px`,
        midY1: `${midY1}px`,
        midX2: `${midX2}px`,
        midY2: `${midY2}px`,
        midX3: `${midX3}px`,
        midY3: `${midY3}px`,
        size: Math.random() * 5 + 2,
        color: color,
        speed: speed,
        shape: shape,
        opacity: Math.random() * 0.7 + 0.3
      });
    }
    return newParticles;
  };

  // First button handlers
  const handleMouseEnter = (e) => {
    setIsHovered(true);
    if (buttonRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      setParticles(generateParticles(8, 50, 50));
      setCornerParticles(generateCornerParticles(6, buttonRect));
    }
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setTimeout(() => {
      setParticles([]);
      setTimeout(() => setCornerParticles([]), 1000);
    }, 500);
  };

  // Second button handlers
  const handleMouseEnter2 = (e) => {
    setIsHovered2(true);
    if (buttonRef2.current) {
      const buttonRect = buttonRef2.current.getBoundingClientRect();
      setParticles2(generateParticles(8, 50, 50));
      setCornerParticles2(generateCornerParticles(6, buttonRect));
    }
  };

  const handleMouseLeave2 = () => {
    setIsHovered2(false);
    setTimeout(() => {
      setParticles2([]);
      setTimeout(() => setCornerParticles2([]), 1000);
    }, 500);
  };

  useEffect(() => {
    if (isHovered && buttonRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      
      const particleInterval = setInterval(() => {
        setParticles(prev => [...prev, ...generateParticles(2)]);
      }, 200);
      
      const cornerParticleInterval = setInterval(() => {
        setCornerParticles(prev => {
          const updatedParticles = prev.filter(p => 
            Date.now() - p.createdAt < 4000
          );
          
          const newParticles = generateCornerParticles(2, buttonRect).map(p => ({
            ...p,
            createdAt: Date.now()
          }));
          
          return [...updatedParticles, ...newParticles];
        });
      }, 300);
      
      return () => {
        clearInterval(particleInterval);
        clearInterval(cornerParticleInterval);
      };
    }
  }, [isHovered]);

  useEffect(() => {
    if (isHovered2 && buttonRef2.current) {
      const buttonRect = buttonRef2.current.getBoundingClientRect();
      
      const particleInterval = setInterval(() => {
        setParticles2(prev => [...prev, ...generateParticles(2)]);
      }, 200);
      
      const cornerParticleInterval = setInterval(() => {
        setCornerParticles2(prev => {
          const updatedParticles = prev.filter(p => 
            Date.now() - p.createdAt < 4000
          );
          
          const newParticles = generateCornerParticles(2, buttonRect).map(p => ({
            ...p,
            createdAt: Date.now()
          }));
          
          return [...updatedParticles, ...newParticles];
        });
      }, 300);
      
      return () => {
        clearInterval(particleInterval);
        clearInterval(cornerParticleInterval);
      };
    }
  }, [isHovered2]);

  useEffect(() => {
    const updateParticles = () => {
      if (isHovered && buttonRef.current) {
        const buttonRect = buttonRef.current.getBoundingClientRect();
        setCornerParticles(prev => 
          prev.map(particle => ({
            ...particle,
            startX: `${buttonRect.right - 8}px`,
            startY: `${buttonRect.bottom - 8}px`
          }))
        );
      }
      if (isHovered2 && buttonRef2.current) {
        const buttonRect = buttonRef2.current.getBoundingClientRect();
        setCornerParticles2(prev => 
          prev.map(particle => ({
            ...particle,
            startX: `${buttonRect.right - 8}px`,
            startY: `${buttonRect.bottom - 8}px`
          }))
        );
      }
    };

    window.addEventListener('scroll', updateParticles);
    window.addEventListener('resize', updateParticles);

    return () => {
      window.removeEventListener('scroll', updateParticles);
      window.removeEventListener('resize', updateParticles);
    };
  }, [isHovered, isHovered2]);

  // Intersection Observer for animations on scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Handle product navigation with scroll to top
  const handleProductNavigation = (product, route) => {
    scrollToTop();
    setTimeout(() => {
      navigate(route, { 
        state: { product } 
      });
    }, 100);
  };

  if (loading) {
    return (
      <div className="container text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container" ref={sectionRef}>
      {cornerParticles.map(particle => (
        <div
          key={particle.id}
          className={`bottom-corner-leak-particle bottom-corner-leak-particle--${particle.speed} bottom-corner-leak-particle--${particle.shape}`}
          style={{
            width: `${particle.size}px`,
            height: `${particle.size}px`,
            background: particle.color,
            left: 0,
            top: 0,
            '--start-x': particle.startX,
            '--start-y': particle.startY,
            '--mid-x1': particle.midX1,
            '--mid-y1': particle.midY1,
            '--mid-x2': particle.midX2,
            '--mid-y2': particle.midY2,
            '--mid-x3': particle.midX3,
            '--mid-y3': particle.midY3,
            '--end-x': particle.endX,
            '--end-y': particle.endY,
            opacity: particle.opacity
          }}
        />
      ))}

      {cornerParticles2.map(particle => (
        <div
          key={particle.id}
          className={`bottom-corner-leak-particle bottom-corner-leak-particle--${particle.speed} bottom-corner-leak-particle--${particle.shape}`}
          style={{
            width: `${particle.size}px`,
            height: `${particle.size}px`,
            background: particle.color,
            left: 0,
            top: 0,
            '--start-x': particle.startX,
            '--start-y': particle.startY,
            '--mid-x1': particle.midX1,
            '--mid-y1': particle.midY1,
            '--mid-x2': particle.midX2,
            '--mid-y2': particle.midY2,
            '--mid-x3': particle.midX3,
            '--mid-y3': particle.midY3,
            '--end-x': particle.endX,
            '--end-y': particle.endY,
            opacity: particle.opacity
          }}
        />
      ))}

      {/* Centered Heading Section */}
      <div className="row justify-content-center text-center py-5">
        <div className="col-lg-8">
          <h2 className="business-solution-heading mb-4">
            Our <span style={{borderBottom: "5px solid #9374FF"}}>Latest Products</span>
          </h2>
          <p className="business-solution-subheading">
            Discover our innovative solutions designed to transform your business and drive growth
          </p>
        </div>
      </div>

      {/* First Section */}
      <div className="row align-items-center py-5 px-3 px-md-5">
        <div className={`col-lg-6 mb-4 mb-lg-0 ${isVisible ? 'animate-fade-scale delay-100' : ''}`}>
          <img
            src={`${API_URL}/${firstProduct?.featured_image_url || "/images/Company.png"}`}
            alt={firstProduct?.name || "Business Solution"}
            className="section-img"
            onError={(e) => {
              e.target.src = '/images/Company.png';
            }}
          />
        </div>
        <div className={`col-lg-6 ps-lg-5`}>
          <h1 className={`display-5 fw-bold mb-4 ${isVisible ? 'animate-fade-down delay-200' : ''}`}>
            {firstProduct?.name || "Perfect Solution For Your Company"}
          </h1>
          <p className={`text-muted mb-4 lead ${isVisible ? 'animate-fade-up delay-300' : ''}`}>
            {firstProduct ? truncateDescription(firstProduct.description) : 
              "Develop a website by finding a product identity that has value and branding to become a characteristic of a company. We will also facilitate the business marketing of these products with our SEO experts so that they become a ready-to-use website and help sell a product from the company."}
          </p>
          <div className={`d-flex justify-content-start align-items-center mt-5 w-100 gap-3 ${isVisible ? 'animate-bounce-in delay-400' : ''}`}>
            <button
              ref={buttonRef}
              className={`modern-btn ${isHovered ? 'modern-btn--hovered' : ''}`}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              onClick={() => firstProduct && handleProductNavigation(firstProduct, `/product/${firstProduct.slug}`)}
            >
              <span className="modern-btn__text">
                {firstProduct ? 'View Product' : 'Know More'}
                <FontAwesomeIcon className='mx-2' icon={faArrowUpRightFromSquare}/> 
              </span>
              
              <span className="modern-btn__border modern-btn__border--top"></span>
              <span className="modern-btn__border modern-btn__border--right"></span>
              <span className="modern-btn__border modern-btn__border--bottom"></span>
              <span className="modern-btn__border modern-btn__border--left"></span>
              
              <div className="modern-btn__particles">
                {particles.map(particle => (
                  <span
                    key={particle.id}
                    className="modern-btn__particle"
                    style={{
                      left: `${particle.x}%`,
                      top: `${particle.y}%`,
                      width: `${particle.size}px`,
                      height: `${particle.size}px`,
                      animationDuration: `${particle.duration}s`,
                      animationDelay: `${particle.delay}s`
                    }}
                  />
                ))}
              </div>
              
              <span className="modern-btn__glow"></span>
            </button>
          </div>
        </div>
      </div>

      {/* Second Section */}
      <div className="row align-items-center py-5 px-3 px-md-5 bg-white">
        <div className={`col-lg-6 order-lg-2 mb-4 mb-lg-0 ${isVisible ? 'animate-rotate-in delay-500' : ''}`}>
          <img
            src={`${API_URL}/${secondProduct?.featured_image_url}` || "/images/Business1.png"}
            alt={secondProduct?.name || "Quality Service"}
            className="section-img"
            onError={(e) => {
              e.target.src = '/images/Business1.png';
            }}
          />
        </div>
        <div className={`col-lg-6 order-lg-1 pe-lg-5`}>
          <h2 className={`display-5 fw-bold mb-5 ${isVisible ? 'animate-slide-right delay-500' : ''}`}>
            {secondProduct?.name || "You Will Get Best Quality Service"}
          </h2>
          
          <p className={`text-muted mb-4 lead ${isVisible ? 'animate-fade-up delay-600' : ''}`}>
            {secondProduct ? truncateDescription(secondProduct.description) : 
              "Develop a website by finding a product identity that has value and branding to become a characteristic of a company."}
          </p>

          <div className={`d-flex justify-content-start align-items-center mt-4 w-100 gap-3 ${isVisible ? 'animate-bounce-in delay-700' : ''}`}>
            <button
              ref={buttonRef2}
              className={`modern-btn ${isHovered2 ? 'modern-btn--hovered' : ''}`}
              onMouseEnter={handleMouseEnter2}
              onMouseLeave={handleMouseLeave2}
              onClick={() => secondProduct && handleProductNavigation(secondProduct, `/product/${secondProduct.slug}`)}
            >
              <span className="modern-btn__text">
                {secondProduct ? 'View Product' : 'Know More'}
                <FontAwesomeIcon className='mx-2' icon={faArrowUpRightFromSquare}/> 
              </span>
              
              <span className="modern-btn__border modern-btn__border--top"></span>
              <span className="modern-btn__border modern-btn__border--right"></span>
              <span className="modern-btn__border modern-btn__border--bottom"></span>
              <span className="modern-btn__border modern-btn__border--left"></span>
              
              <div className="modern-btn__particles">
                {particles2.map(particle => (
                  <span
                    key={particle.id}
                    className="modern-btn__particle"
                    style={{
                      left: `${particle.x}%`,
                      top: `${particle.y}%`,
                      width: `${particle.size}px`,
                      height: `${particle.size}px`,
                      animationDuration: `${particle.duration}s`,
                      animationDelay: `${particle.delay}s`
                    }}
                  />
                ))}
              </div>
              
              <span className="modern-btn__glow"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessSolution;